// React
import React from "react";
import { render } from "react-dom";
import { createMemoryHistory } from "history";
import { Router, Route } from "react-router";
import { Provider } from "react-redux";
import registerServiceWorker from "./registerServiceWorker";
import { store } from "./store.js";

// RAGE CLICK COMPONENTS
import SceneManager from "./components/scenemanager/SceneManager.js";
import StartScreen from "./components/scenes/StartScreen";
import Intro from "./components/scenes/Intro";
import HighScores from "./components/scenes/HighScores";
// import FSPlayback from "./components/scenes/FSPlayback";
import Winner from "./components/scenes/Winner";

import "./index.css";
// require('viewport-units-buggyfill').init();

const injectTapEventPlugin = require( "react-tap-event-plugin" );
injectTapEventPlugin();

const history = createMemoryHistory( {
  	initialEntries: [ '/', '/intro', '/play', '/win', '/replay', '/scores' ],
  	initialIndex: 0
} );

render(
	<Provider store={ store }>
		<Router history={ history }>
			<Route path="/"     component={ StartScreen } />
			<Route path="/intro"  component={ Intro } />
			<Route path="/play"   component={ SceneManager } after={ "/win" } />
			<Route path="/win"    component={ Winner } />
			<Route path="/scores" component={ HighScores } />
		</Router>
	</Provider>,
	document.getElementById("root")
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js